exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[dir] #financiel-register-tabs .vs-tabs--content {\n  padding: 0 10px 23px !important;\n}", ""]);

// exports
